ticket.ticketPromoModule = {
    // Funkcia na vyrenderovanie freebetov alebo bonifikacii na tikete
    ctRenderFreebetBonifications: function(data, showHeader) {
        try {
            /**
             * "Freebets": [{
                    "Amount": 5,
                    "CategoryDescription": [
                        "Futbal->Anglicko->Premier League",
                        "Futbal->Liga Majstrov"
                    ],
                    "FreebetID": 5780,
                    "FreebetName": "Test Freebet 5",
                    "IsActive": false,
                    "IsApplicable": false,
                    "LiveRequired": false,
                    "MaxRateAll": 50,
                    "MaxRateOdd": 5,
                    "MinOdds": 1,
                    "MinRateAll": 1,
                    "MinRateOdd": 1,
                    "PrematchRequired": false
                }],
             "Bonifications": [{
                    "Applicable": false,
                    "BonificationID": 1,
                    "BonificationValue": 1.2,
                    "MinBet": 2.0,
                    "PointsRequired": 200,
                    "Selected": false
                }],

             */
            if (data.IsEdited) {
                return false;
            }
            if ((profile.Freebet || profile.Bonification) && data && data.PlayerID == stored.PlayerID && data.TYPE == ticket.state.ticketWsTypes.JT) {
                // Checkboxes (Radio buttons)
                $("#freebetList #freebetButtons, #bonificationList #bonificationButtons").empty();
                var isActive, anyActive, isApplicable, btnColor, controlgroup, checkboxes;

                // Priprava dat pre render freebetList
                if (profile.Freebet && data.Freebets && data.Freebets.length > 0) {
                    stored.anyApplicableFb = false, stored.FbBonButtons.fb = true, btnColor = "a", anyActive = controlgroup = checkboxes = "";
                    if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) console.log(data.Freebets);

                    for (i = 0; i < data.Freebets.length; i++) {
                        isActive = "";
                        isApplicable = false;

                        if (data.Freebets[i].IsActive) {
                            stored.FreebetID = data.Freebets[i].FreebetID;
                            isActive = anyActive = "checked";
                        }
                        if (data.Freebets[i].IsApplicable) isApplicable = stored.anyApplicableFb = true;

                        checkboxes += '<input type="radio" onclick="ticket.ticketPromoModule.setFreebet(' + data.Freebets[i].FreebetID + ', ' + isApplicable + ')" id="'
                            + data.Freebets[i].FreebetID + '" data-theme="a" class="custom"'
                            + isActive + ' /><label applicable="'
                            + isApplicable + '" for="'
                            + data.Freebets[i].FreebetID + '" category-description="'
                            + data.Freebets[i].CategoryDescription + '" amount="'
                            + data.Freebets[i].Amount + '" amount-currency="'
                            + data.Freebets[i].Amount + profile.Currency + '" min-odds="'
                            + data.Freebets[i].MinOdds + '" min-rate-odd="'
                            + data.Freebets[i].MinRateOdd + '" max-rate-odd="'
                            + data.Freebets[i].MaxRateOdd + '" min-rate-all="'
                            + data.Freebets[i].MinRateAll + '" max-rate-all="'
                            + data.Freebets[i].MaxRateAll + '" prematch-required="'
                            + data.Freebets[i].PrematchRequired + '" live-required="'
                            + data.Freebets[i].LiveRequired + '" fb-created="'
                            + data.Freebets[i].Created + '" fb-valid-to="'
                            + data.Freebets[i].ValidTo + '">'
                            + data.Freebets[i].FreebetName + '</label>';
                    }

                    // Vyrenderuje freebetList
                    controlgroup = $("<div/>", {"data-role": "controlgroup"}).append(checkboxes);
                    $("#freebetList #freebetButtons").append(controlgroup.controlgroup());
                    $("#freebetList #freebetButtons [type=radio]").checkboxradio();
                    $("#freebetList #freebetButtons [data-role=controlgroup]").controlgroup("refresh");
                    $("#freebetList #triangle").removeClass("withOneButton withMultipleButtons");
                    data.Freebets.length < 2 ? $("#freebetList #triangle").addClass("withOneButton") : $("#freebetList #triangle").addClass("withMultipleButtons");
                    shared.scrollModule.scrollReload("freebetList", "reload");

                    // Prida sipku ku kazdemu freebet buttonu
                    if (profile.FlatCSS) {
                        $("#freebetList .ui-radio label .ui-btn-inner").append("<div class='flat-collapse icon-arrow-down'></div>");
                        if (stored.FreebetID) {
                            $("#freebetList label[for='" + stored.FreebetID + "'] .flat-collapse")
                                .removeClass().addClass('flat-collapse icon-arrow-up');
                        }
                    }

                    // Nastavenie farby tlacidla Freebet
                    if (anyActive) {
                        btnColor = "e";
                    } else if (stored.anyApplicableFb) {
                        btnColor = "b";
                    }

                    if (profile.FlatCSS) {
                        if (anyActive) {
                            $("#freebetAvailable .flat-freebet-dot").hide();
                        } else {
                            $("#freebetAvailable .flat-freebet-dot").show();
                        }
                    }

                    $("#footer-sidebar #freebetAvailable a").buttonMarkup({theme: btnColor})
                        .find(".ui-btn-text span").text(data.Freebets.length);

                    // Ak tiketova sluzba nevrati ziaden oznaceny freebet tak sa vymaze stored.FreebetID
                    var freebetID = stored.FreebetID;
                    if (stored.notApplicableFreebetID) {
                        freebetID = stored.notApplicableFreebetID;
                    }
                    if (!ticket.ticketPromoModule.showFreebetBonificationHeader(anyActive, "freebet", showHeader, freebetID) && stored.FreebetID) {
                        stored.FreebetID = null;
                        stored.OverallTotalBet = 0;
                    }
                } else {
                    // Ziaden dostupny freebet
                    ticket.ticketPromoModule.clearFreebetBonification(true, true, "freebet");
                }

                // Priprava dat pre render bonificationList
                if (profile.Bonification && data.Bonifications && data.Bonifications.length > 0) {
                    stored.anyApplicableBon = false, stored.FbBonButtons.bon = true, btnColor = "a", anyActive = controlgroup = checkboxes = "";
                    if (profile.ConsoleLog || profile.ConsoleLog$.Ticket) console.log(data.Bonifications);

                    for (i = 0; i < data.Bonifications.length; i++) {
                        isActive = "";
                        isApplicable = false;
                        bonificationLabel = "";

                        if (data.Bonifications[i].Selected) {
                            stored.BonificationID = data.Bonifications[i].BonificationID;
                            isActive = anyActive = "checked";
                            $("#footer-sidebar #rateMultiplier").text(" x " + shared.floor2(data.Bonifications[i].BonificationValue, 2));
                        }
                        if (data.Bonifications[i].Applicable && stored.Balance >= data.Bonifications[i].MinBet) isApplicable = stored.anyApplicableBon = true;

                        if (profile.IsWinCurrency) {
                            bonificationLabel = '<div>' + shared.formatNumber(data.Bonifications[i].WinsRequired, false) + ' ' + profile.WinCurrencySymbol
                            + ' + ' + texts.BonBet + ' ' + data.Bonifications[i].MinBet + profile.Currency + '</div>';
                        } else {
                            bonificationLabel = '<div>' + shared.formatNumber(data.Bonifications[i].PointsRequired, false) + ' ' + texts.BonPoints
                            + ' + ' + texts.BonBet + ' ' + data.Bonifications[i].MinBet + profile.Currency + '</div>';
                        }

                        checkboxes += '<input type="radio" onclick="ticket.ticketPromoModule.setBonification(' + data.Bonifications[i].BonificationID + ', ' + isApplicable + ')" id="'
                            + data.Bonifications[i].BonificationID + '" data-theme="a" class="custom"'
                            + isActive + ' /><label applicable="'
                            + isApplicable + '" for="'
                            + data.Bonifications[i].BonificationID + '" applicability="'
                            + data.Bonifications[i].Applicable + '" bonification-value="'
                            + data.Bonifications[i].BonificationValue + '" min-bet="'
                            + data.Bonifications[i].MinBet + '" min-odds="'
                            + data.Bonifications[i].MinOddsCount + '" min-rate-all="'
                            + data.Bonifications[i].MinOverallRate + '" points-required="'
                            + data.Bonifications[i].PointsRequired + '" win-currency-required="'
                            + data.Bonifications[i].WinsRequired + '">'
                            + shared.floor2(data.Bonifications[i].BonificationValue, 2) + ' ' + texts.BonButton
                            + bonificationLabel + '</label>';
                    }

                    // Vyrenderuje bonificationList
                    controlgroup = $("<div/>", {"data-role": "controlgroup"}).append(checkboxes);
                    $("#bonificationList #bonificationButtons").append(controlgroup.controlgroup());
                    $("#bonificationList #bonificationButtons [type=radio]").checkboxradio();
                    $("#bonificationList #bonificationButtons [data-role=controlgroup]").controlgroup("refresh");
                    $("#bonificationList #triangle").removeClass("withOneButton withMultipleButtons");
                    data.Bonifications.length < 2 ? $("#bonificationList #triangle").addClass("withOneButton") : $("#bonificationList #triangle").addClass("withMultipleButtons");
                    shared.scrollModule.scrollReload("bonificationList", "reload");

                    // Prida sipku ku kazdemu bonification buttonu
                    if (profile.FlatCSS) {
                        $("#bonificationList .ui-radio label .ui-btn-inner").append("<div class='flat-collapse icon-arrow-down'></div>");
                        if (stored.BonificationID) {
                            $("#bonificationList label[for='" + stored.BonificationID + "'] .flat-collapse")
                                .removeClass().addClass('flat-collapse icon-arrow-up');
                        }
                    }

                    // Nastavenie farby tlacidla Bonifikacia
                    if (anyActive) {
                        btnColor = "e";
                    } else if (stored.anyApplicableBon) {
                        btnColor = "b";
                    }
                    if (profile.FlatCSS) {
                        if (anyActive) {
                            $("#bonificationAvailable .flat-bonification-dot").hide();
                        } else {
                            $("#bonificationAvailable .flat-bonification-dot").show();
                        }
                    }
                    $("#footer-sidebar #bonificationAvailable a").buttonMarkup({theme: btnColor})
                        .find(".ui-btn-text span").text(data.Bonifications.length);

                    // Ak tiketova sluzba nevrati ziadnu oznacenu bonifikaciu tak sa vymaze stored.BonificationID
                    var bonificationID = stored.BonificationID;
                    if (stored.notApplicableBonificationID) {
                        bonificationID = stored.notApplicableBonificationID;
                    }
                    if (!ticket.ticketPromoModule.showFreebetBonificationHeader(anyActive, "bonification", showHeader, bonificationID) && stored.BonificationID) {
                        stored.BonificationID = null;
                        stored.OverallTotalBet = 0;
                    }

                } else {
                    // Ziadena dostupna bonifikacia
                    ticket.ticketPromoModule.clearFreebetBonification(true, true, "bonification");
                }

                // Zobrazenie tlacidiel Freebet a Bonifikacia
                if (stored.FbBonButtons.fb || stored.FbBonButtons.bon) {

                    //Zobrazenie tlacidiel freebet, bonifikacia
                    ticket.ticketPromoModule.freebetBonificationShowButtons();

                    // Nastavenie hodnoty vkladu za freebet
                    ticket.checkSum(data);

                    // Tipy, ktore maju byt aktualizovane
                    if (data.Odds) {
                        for (i = 0; i < data.Odds.length; i++) {
                            ticket.ticketOddModule.oddChangedTicket(data.Odds[i]);
                            ticket.ticketOddModule.addRemoveOddFromList(data.Odds[i])
                        }
                        if (!ticket.state.getState().isEditTicket) {
                            modal.errorResolver();
                        }
                    }

                    $("#freebetButtons, #bonificationButtons").removeAttr("class");
                    return true;

                } else {
                    $("#footer-sidebar .simple-options #flexGrid").removeClass().addClass("flex-3").show();
                    return false;
                }

            } else {
                // Rozpisovy tiket a neprihlaseny hrac ma freebet a bonifikaciu ZAKAZANU
                if (!stored.PlayerID ||
                    (!profile.Freebet && !profile.Bonification)) {
                    ticket.ticketPromoModule.clearFreebetBonification(true, true);
                } else if (!profile.Freebet) {
                    ticket.ticketPromoModule.clearFreebetBonification(true, true, "freebet");
                } else if (!profile.Bonification) {
                    ticket.ticketPromoModule.clearFreebetBonification(true, true, "bonification");
                } else if (data.TYPE !== ticket.state.ticketWsTypes.JT) {
                    ticket.ticketPromoModule.clearFreebetBonification(true);
                }
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    // Funkcia na zobrazenie/skrytie tlacidiel freebet a/alebo bonifikacie
    freebetBonificationShowButtons: function(doNotShow) {
        if (doNotShow || (!doNotShow && !stored.PlayerID)) {
            // Nezobrazuj bonifikaciu ani freebet
            $("#footer-sidebar .simple-options #flexGrid").removeClass().addClass("flex-3");
        
            $("#footer-sidebar .simple-options .ui-block-c").show();
            $("#footer-sidebar #freebetAvailable").hide();
            $("#footer-sidebar #bonificationAvailable").hide();
        } else {
            // Zobrazene aspon jedno tlacidlo
            $("#footer-sidebar .simple-options .ui-block-c").hide();
            // Zobrazene obe tlacidla naraz
            if (stored.FbBonButtons.fb && stored.FbBonButtons.bon) {
                $("#footer-sidebar .simple-options #flexGrid").removeClass().addClass("flex-5");
            } else if (stored.FbBonButtons.fb || stored.FbBonButtons.bon) {
                $("#footer-sidebar .simple-options #flexGrid").removeClass().addClass("flex-4");
            }
            // Tlacitdlo Freebet
            if (stored.FbBonButtons.fb) $("#footer-sidebar #freebetAvailable").show();
            //  Tlacidlo Bonifikacia
            if (stored.FbBonButtons.bon) $("#footer-sidebar #bonificationAvailable").show();
        }
    },

    // Funkcia na zobrazenie stavu zvoleneho freebetu alebo bonifikacie
    showFreebetBonificationHeader: function(isActive, type, showHeader, freebetBonificationID) {
        try {
            switch (type) {
                case "freebet":
                    if (stored.BonificationID) {
                        $("#freebetHeader").hide();
                    } else {
                        // Prehodi hlavicku ku konkretnemu freebetu
                        if (freebetBonificationID) {
                            $("#freebetButtons #freebetInfo, #bonificationButtons #bonificationInfo").remove();
                            $("#freebetInfo").clone().removeAttr("class").insertAfter($("#freebetButtons #" + freebetBonificationID).parent());
                            if (profile.FlatCSS) {
                                $("#freebetButtons #freebetHeader").remove();
                                $("#freebetHeader").clone().removeAttr("class").show().insertAfter($("#freebetButtons #" + freebetBonificationID).parent());
                            }
                        }
                        if (isActive) {
                            $("#freebetHeader .freebet-status").html(texts.FbIsActive).removeClass("flat-bon-freebet-not-usable").addClass("flat-bon-freebet-usable");
                            $("#freebetHeader .ui-icon-main").removeClass("bonus-isnot-active").addClass("bonus-is-active");
                            $("#freebetHeader").show();
                            $("#freebetButtons #freebetInfo").addClass("flat-bon-freebet-usable");
                            ticket.ticketPromoModule.freebetBonificationToggle('freebet');
                            return true;
                        } else {
                            if (showHeader == type || stored.notApplicableFreebetID) {
                                delete stored.notApplicableFreebetID;
                                $("#freebetHeader .freebet-status").html(texts.FbIsNotActive).removeClass("flat-bon-freebet-usable").addClass("flat-bon-freebet-not-usable");
                                $("#freebetHeader .ui-icon-main").removeClass("bonus-is-active").addClass("bonus-isnot-active");
                                $("#freebetButtons #freebetInfo").removeClass("flat-bon-freebet-usable");
                                $("#freebetHeader").show();
                            } else {
                                $("#freebetHeader").hide();
                            }
                            return false;
                        }
                    }
                    break;
                case "bonification":
                    if (stored.FreebetID) {
                        $("#bonificationHeader").hide();
                    } else {
                        // Prehodi hlavicku ku konkretnej bonifikacii
                        if (freebetBonificationID) {
                            $("#bonificationButtons #bonificationInfo, #freebetButtons #freebetInfo").remove();
                            $("#bonificationInfo").clone().removeAttr("class").insertAfter($("#bonificationButtons #" + freebetBonificationID).parent());
                            if (profile.FlatCSS) {
                                $("#bonificationButtons #bonificationHeader").remove();
                                $("#bonificationHeader").clone().removeAttr("class").show().insertAfter($("#bonificationButtons #" + freebetBonificationID).parent());
                            }
                        }
                        if (isActive) {
                            $("#bonificationHeader .bonification-status").html(texts.BonIsActive).removeClass("flat-bon-freebet-not-usable").addClass("flat-bon-freebet-usable");
                            $("#bonificationHeader .ui-icon-main").removeClass("bonus-isnot-active").addClass("bonus-is-active");
                            $("#bonificationHeader").show();
                            $("#bonificationButtons #bonificationInfo").addClass("flat-bon-freebet-usable");
                            ticket.ticketPromoModule.freebetBonificationToggle("bonification");
                            return true;
                        } else {
                            if (showHeader == type || stored.notApplicableBonificationID) {
                                delete stored.notApplicableBonificationID;
                                $("#bonificationHeader .bonification-status").html(texts.BonIsNotActive).removeClass("flat-bon-freebet-usable").addClass("flat-bon-freebet-not-usable");
                                $("#bonificationHeader .ui-icon-main").removeClass("bonus-is-active").addClass("bonus-isnot-active");
                                $("#bonificationButtons #bonificationInfo").removeClass("flat-bon-freebet-usable");
                                $("#bonificationHeader").show();
                            } else {
                                $("#bonificationHeader").hide();
                            }
                            return false;
                        }
                    }
                    break;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Toggle funkcia na zobrazenie zoznamu freebetov alebo bonifikacii
    freebetBonificationToggle: function(list) {
        try {
            if (list === "rateChange") {
                if (!$("#rateChangesList").is(':visible')) {
                    $("#bonificationList, #freebetList").hide();
                    if ($("#freebetHeader .ui-icon-main").hasClass("bonus-isnot-active")) $("#freebetHeader").hide();
                    if ($("#bonificationHeader .ui-icon-main").hasClass("bonus-isnot-active")) $("#bonificationHeader").hide();
                    $("#bonificationAvailable").removeClass("list-opened");
                    $("#freebetAvailable").removeClass("list-opened");
                    $("#rateChanges").addClass("list-opened");
                    if (!$("#depositDial").is(":visible")) $("#hideOffer").addClass("hide-offer-active");
                    if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                        ticket.ticketCombiModule.hideCombinationList();
                    }
                    $("#footer-sidebar .rate-changes-btn .ui-btn-text").text(texts.RateChangeHide);
                    $("#rateChangesList").show();
        
                } else {
                    $("#freebetAvailable").removeClass("list-opened");
                    $("#bonificationAvailable").removeClass("list-opened");
                    $("#rateChanges").removeClass("list-opened");
                    $("#footer-sidebar .rate-changes-btn .ui-btn-text").text(texts.RateChangeShow);
        
                    if (!$("#depositDial").is(":visible")) $("#hideOffer").removeClass();
                    $("#rateChangesList").hide();
                }
            }
            if (profile.Freebet || profile.Bonification) {
                switch (list) {
                    case "freebet":
                        if (!$("#freebetList").is(':visible') && !$("#freebetButtons").is(':empty')) {
                            $("#bonificationList, #rateChangesList").hide();
                            if ($("#freebetHeader .ui-icon-main").hasClass("bonus-isnot-active")) $("#freebetHeader").hide();
                            $("#bonificationAvailable").removeClass("list-opened");
                            $("#rateChanges").removeClass("list-opened");
                            $("#freebetAvailable").addClass("list-opened");
                            $("#footer-sidebar .rate-changes-btn .ui-btn-text").html(texts.RateChangeShow);
                            if (!$("#depositDial").is(":visible")) $("#hideOffer").addClass("hide-offer-active");
                            $("#freebetList").show();

                        } else {
                            $("#freebetAvailable").removeClass("list-opened");
                            if (!$("#depositDial").is(":visible")) $("#hideOffer").removeClass();
                            $("#freebetList").hide();
                        }
                        break;
                    case "bonification":
                        if (!$("#bonificationList").is(':visible') && !$("#bonificationButtons").is(':empty')) {
                            $("#rateChangesList, #freebetList").hide();
                            if ($("#bonificationHeader .ui-icon-main").hasClass("bonus-isnot-active")) $("#bonificationHeader").hide();
                            $("#freebetAvailable").removeClass("list-opened");
                            $("#rateChanges").removeClass("list-opened");
                            $("#bonificationAvailable").addClass("list-opened");
                            $("#footer-sidebar .rate-changes-btn .ui-btn-text").html(texts.RateChangeShow);
                            if (!$("#depositDial").is(":visible")) $("#hideOffer").addClass("hide-offer-active");
                            $("#bonificationList").show();
                        } else {
                            $("#bonificationAvailable").removeClass("list-opened");
                            if (!$("#depositDial").is(":visible")) $("#hideOffer").removeClass();
                            $("#bonificationList").hide();
                        }
                        break;
                }
                return true;
            } else {
                $("#freebetList, #bonificationList").hide();
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia ktora odznaci tlacitka freebet a bonifkacia
    clearFreebetBonification: function(hideList, notAvailable, type) {
        try {
            if (!type || type == "freebet") {
                stored.FreebetID = null;
                $("#freebetList #freebetButtons [type=radio]").prop("checked", false).checkboxradio("refresh");
                $("#freebetButtons").removeAttr("class");
                if (hideList) {
                    $("#freebetList, #freebetInfo").hide();
                    $("#freebetAvailable a").buttonMarkup({theme: "a"});
                }
                if (notAvailable) {
                    stored.FbBonButtons.fb = false;
                    $("#freebetAvailable").hide();
                    $("#footer-sidebar .simple-options .ui-block-c").show();
                }
            }

            if (!type || type == "bonification") {
                stored.BonificationID = null;
                $("#footer-sidebar #rateMultiplier").empty();
                $("#bonificationList #bonificationButtons [type=radio]").prop("checked", false).checkboxradio("refresh");
                $("#bonificationButtons").removeAttr("class");
                if (hideList) {
                    $("#bonificationList, #bonificationInfo").hide();
                    $("#bonificationAvailable a").buttonMarkup({theme: "a"});
                }
                if (notAvailable) {
                    stored.FbBonButtons.bon = false;
                    $("#bonificationAvailable").hide();
                    $("#footer-sidebar .simple-options .ui-block-c").show();
                }
            }

            // Ak maju byt skryte obe tlacidla
            if (notAvailable && !stored.FbBonButtons.fb && !stored.FbBonButtons.bon) {
                $("#footer-sidebar .simple-options #flexGrid").removeClass().addClass("flex-3");
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zvolenie konkretneho freebetu pred stavenim tiketu
    setFreebet: function(freebetID, isApplicable) {
        try {
            if (profile.Freebet) {
                $("#freebetButtons").addClass("lock-btn");
                shared.scrollModule.scrollReload("freebetList", "save");

                // Info o Freebet
                var category, fbRequried = "";

                // $("#freebetInfo #FbName").text($("label[for='" + freebetID + "'] .ui-btn-text").text());
                $("#freebetInfo #FbCategory .ui-block-a").empty();
                category = $("label[for='" + freebetID + "']").attr("category-description").split(",");
                if (category.length) $.each(category, function (i, description) {
                    $("#freebetInfo #FbCategory .ui-block-a").append('<div>' + description + '</div>')
                });

                $("#freebetInfo #FbAmount .ui-block-b")
                    .text(shared.floor2($("label[for='" + freebetID + "']").attr("amount"), 1) + " " + profile.Currency);
                $("#freebetInfo #FbMinOdds .ui-block-b")
                    .text($("label[for='" + freebetID + "']").attr("min-odds"));
                $("#freebetInfo #FbMinRateOdd .ui-block-b")
                    .text(shared.formatNumber(shared.floor2($("label[for='" + freebetID + "']").attr("min-rate-odd"), 2), true));
                $("#freebetInfo #FbMaxRateOdd .ui-block-b")
                    .text(shared.formatNumber(shared.floor2($("label[for='" + freebetID + "']").attr("max-rate-odd"), 2), true));
                $("#freebetInfo #FbMinRateAll .ui-block-b")
                    .text(shared.formatNumber(shared.floor2($("label[for='" + freebetID + "']").attr("min-rate-all"), 2), true));
                $("#freebetInfo #FbMaxRateAll .ui-block-b")
                    .text(shared.formatNumber(shared.floor2($("label[for='" + freebetID + "']").attr("max-rate-all"), 2), true));

                if ($("label[for='" + freebetID + "']").attr("prematch-required") == "true") {
                    fbRequried = texts.FbRequiredYes;
                } else {
                    fbRequried = texts.FbRequiredNo;
                }
                $("#freebetInfo #FbPrematchRequired .ui-block-b").text(fbRequried);

                if ($("label[for='" + freebetID + "']").attr("live-required") == "true") {
                    fbRequried = texts.FbRequiredYes;
                } else {
                    fbRequried = texts.FbRequiredNo;
                }
                $("#freebetInfo #FbLiveRequired .ui-block-b").text(fbRequried);

                $("#freebetInfo #FbCreated .ui-block-b")
                .text($("label[for='" + freebetID + "']").attr("fb-created"));
                $("#freebetInfo #FbValidTo .ui-block-b")
                .text($("label[for='" + freebetID + "']").attr("fb-valid-to"));

                $("#freebetInfo").show();

                if (isApplicable) {
                    if (freebetID != stored.FreebetID) {
                        var requestUrl;
                        $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setfreebet/" + freebetID)
                            .done(function (data) {
                                if (data === Object(data)) {
                                    stored.BonificationID = null;
                                    $("#footer-sidebar #rateMultiplier").empty();

                                    // Nastavenie freebetu
                                    if (data.Errors && !data.Errors.length) {
                                        main.createLog(3, "CentralTicketSetFreebet_Success", "FreebetID: " + freebetID);
                                        stored.FreebetID = freebetID;
                                        ticket.depositDialToggle(true);
                                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data, "freebet");
                                        return true;

                                    } else {
                                        var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                        modal.showErrObj(2, 5, {errObj: errors});
                                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data);
                                        return false;
                                    }
                                } else {
                                    // Neuspesne nastavenie freebetu
                                    main.createLog(2, "CentralTicketSetFreebet_Failed", "FreebetID: " + freebetID + " # AJAX FAILED: not-object");
                                    return false;
                                }
                            })

                            // Neuspesne nastavenie freebetu
                            .fail(function (jqXHR) {
                                jqXHR.requestUrl = requestUrl;
                                main.createLog(2, "CentralTicketSetFreebet_Failed", "FreebetID: " + freebetID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                                $("#freebetList #freebetButtons #" + freebetID + "[type=radio]").prop("checked", true).checkboxradio("refresh");
                                $("#freebetButtons").removeAttr("class");
                                return false;
                            });
                    } else {
                        ticket.ticketPromoModule.removeFreebet();
                    }
                } else if (stored.FreebetID || stored.BonificationID) {
                    stored.notApplicableFreebetID = freebetID;
                    if (stored.FreebetID) ticket.ticketPromoModule.removeFreebet("freebet");
                    if (stored.BonificationID) ticket.ticketPromoModule.removeBonification("bonification");
                    return true;
                } else {
                    if (profile.FlatCSS && freebetID) {
                        $("#freebetList .flat-collapse")
                            .removeClass().addClass('flat-collapse icon-arrow-down');
                        $("#freebetList label[for='" + freebetID + "'] .flat-collapse")
                            .removeClass().addClass('flat-collapse icon-arrow-up');
                    }
                    ticket.ticketPromoModule.showFreebetBonificationHeader(false, "freebet", "freebet", freebetID);
                    $("#freebetButtons").removeAttr("class");
                    return true;
                }

            } else {
                // Freebet je ZAKAZANY
                ticket.ticketPromoModule.clearFreebetBonification(true, true, "freebet");
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne nastavenie freebetu
            main.createLog(2, "CentralTicketSetFreebet_Failed", "FreebetID: " + freebetID + " # ERROR");
            $("#freebetList #freebetButtons #" + freebetID + "[type=radio]").prop("checked", false).checkboxradio("refresh");
            $("#freebetButtons").removeAttr("class");
            return false;
        }
    },

    // Zrusenie freebetu
    removeFreebet: function(showHeader) {
        try {
            $("#freebetButtons").addClass("lock-btn");
            shared.scrollModule.scrollReload("freebetList", "save");

            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/removefreebet")
                .done(function (data) {
                    if (data === Object(data)) {
                        // Uspesne zrusenie freebetu
                        main.createLog(3, "CentralTicketRemoveFreebet_Success");
                        ticket.ticketPromoModule.clearFreebetBonification();

                        // Zrusenie vkladu za freebet
                        stored.OverallTotalBet = 0;
                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data, showHeader);
                        if (data.Freebets && data.Freebets.length) ticket.checkSum(data);
                        return true;

                    } else {
                        // Neuspesne zrusenie freebetu
                        main.createLog(2, "CentralTicketRemoveFreebet_Failed", "# AJAX FAILED: not-object");
                        ticket.ticketWsRetrieve();
                        return false;
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    // Neuspesne zrusenie freebetu
                    main.createLog(2, "CentralTicketRemoveFreebet_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                    ticket.ticketWsRetrieve();
                    return false;
                });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne zrusenie freebetu
            main.createLog(2, "CentralTicketRemoveFreebet_Failed", "# ERROR");
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    // Funkcia otvara/zatvara tabulku podmienok v zozname hracskych freebetov
    triggerFBconditions: function(fbIndex) {
        try {
            var collapsible = $("#freebetsTable .collapsible .table-conditions-" + fbIndex);
            if (collapsible.hasClass("ui-collapsible-collapsed")) {
                collapsible.trigger("expand");
                $("#freebetsTable .fb-list-conditions-" + fbIndex).text(texts.FbConditionsHide);
            } else {
                collapsible.trigger("collapse");
                $("#freebetsTable .fb-list-conditions-" + fbIndex).text(texts.FbConditionsShow);
            }
            shared.scrollModule.scrollButtons("bonuses-freebets");
            return true;
        } catch (e) {
            return false;
        }
    },

    // Zvolenie konkretnej bonifikacie pred stavenim tiketu
    setBonification: function(bonificationID, isApplicable) {
        try {
            if (profile.Bonification) {
                $("#bonificationButtons").addClass("lock-btn");
                shared.scrollModule.scrollReload("bonificationList", "save");

                // Info o Bonifikacii
                var category, bonRequried = "";
                // $("#bonificationInfo #BonName").text($("label[for='" + bonificationID + "'] .ui-btn-text").html().split("<div>")[0]);
                $("#bonificationInfo #BonMinOdds .ui-block-b")
                    .text($("label[for='" + bonificationID + "']").attr("min-odds"));
                $("#bonificationInfo #BonMinRateAll .ui-block-b")
                    .text(shared.formatNumber(shared.floor2($("label[for='" + bonificationID + "']").attr("min-rate-all"), 2), true));
                if (profile.IsWinCurrency) {
                    $("#bonificationInfo #BonPointsRequired").hide();
                    $("#bonificationInfo #BonWinCurrencyRequired .ui-block-b")
                        .text(shared.formatNumber($("label[for='" + bonificationID + "']").attr("win-currency-required"), false));
                } else {
                    $("#bonificationInfo #BonWinCurrencyRequired").hide();
                    $("#bonificationInfo #BonPointsRequired .ui-block-b")
                        .text(shared.formatNumber($("label[for='" + bonificationID + "']").attr("points-required"), false));
                }
                $("#bonificationInfo #BonMinBet .ui-block-b")
                    .text(shared.floor2($("label[for='" + bonificationID + "']").attr("min-bet"), 1) + " " + profile.Currency);
                $("#bonificationInfo").show();

                if (isApplicable) {
                    if (bonificationID != stored.BonificationID) {
                        var requestUrl;
                        $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/setbonification/" + bonificationID)
                            .done(function (data) {
                                if (data === Object(data)) {
                                    stored.FreebetID = null;

                                    // Nastavenie bonifikacie
                                    if (data.Errors && !data.Errors.length) {
                                        main.createLog(3, "CentralTicketSetBonification_Success", "BonificationID: " + bonificationID);
                                        stored.BonificationID = bonificationID;
                                        ticket.depositDialToggle(true);
                                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data, "bonification");
                                        return true;

                                    } else {
                                        var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                                        modal.showErrObj(2, 5, {errObj: errors});
                                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data);
                                        return false;
                                    }
                                } else {
                                    // Neuspesne nastavenie bonifikacie
                                    main.createLog(2, "CentralTicketSetBonification_Failed", "BonificationID: " + bonificationID + " # AJAX FAILED: not-object");
                                    return false;
                                }
                            })

                            // Neuspesne nastavenie bonifikacie
                            .fail(function (jqXHR) {
                                jqXHR.requestUrl = requestUrl;
                                main.createLog(2, "CentralTicketSetBonification_Failed", "BonificationID: " + bonificationID + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                                $("#bonificationList #bonificationButtons #" + bonificationID + "[type=radio]").prop("checked", false).checkboxradio("refresh");
                                $("#bonificationButtons").removeAttr("class");
                                return false;
                            });
                    } else {
                        ticket.ticketPromoModule.removeBonification();
                    }
                } else if (stored.FreebetID || stored.BonificationID) {
                    stored.notApplicableBonificationID = bonificationID;
                    if (stored.BonificationID) ticket.ticketPromoModule.removeBonification("bonification");
                    if (stored.FreebetID) ticket.ticketPromoModule.removeFreebet("freebet");
                    return true;
                } else {
                    if (profile.FlatCSS && bonificationID) {
                        $("#bonificationList .flat-collapse")
                            .removeClass().addClass('flat-collapse icon-arrow-down');

                        $("#bonificationList label[for='" + bonificationID + "'] .flat-collapse")
                            .removeClass().addClass('flat-collapse icon-arrow-up');
                    }
                    ticket.ticketPromoModule.showFreebetBonificationHeader(false, "bonification", "bonification", bonificationID);
                    $("#bonificationButtons").removeAttr("class");
                    return true;
                }
            } else {
                // Bonifikacia je ZAKAZANA
                ticket.ticketPromoModule.clearFreebetBonification(true, true, "bonification");
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne nastavenie bonifikacie
            main.createLog(2, "CentralTicketSetBonification_Failed", "BonificationID: " + bonificationID + " # ERROR");
            $("#bonificationList #bonificationButtons #" + bonificationID + "[type=radio]").prop("checked", true).checkboxradio("refresh");
            $("#bonificationButtons").removeAttr("class");
            return false;
        }
    },

    // Zrusenie bonifikacie
    removeBonification: function(showHeader) {
        try {
            $("#bonificationButtons").addClass("lock-btn");
            shared.scrollModule.scrollReload("bonificationList", "save");

            var requestUrl;
            $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/removebonification/" + stored.BonificationID)
                .done(function (data) {
                    if (data === Object(data)) {
                        // Uspesne zrusenie bonifikacie
                        main.createLog(3, "CentralTicketRemoveBonification_Success");
                        ticket.ticketPromoModule.clearFreebetBonification();

                        // Zrusenie vkladu za bonifikaciu
                        stored.OverallTotalBet = 0;
                        ticket.ticketPromoModule.ctRenderFreebetBonifications(data, showHeader);
                        if (data.Bonifications && data.Bonifications.length) ticket.checkSum(data);
                        return true;

                    } else {
                        // Neuspesne zrusenie bonifikacie
                        main.createLog(2, "CentralTicketRemoveBonification_Failed", "# AJAX FAILED: not-object");
                        ticket.ticketWsRetrieve();
                        return false;
                    }
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    // Neuspesne zrusenie bonifikacie
                    main.createLog(2, "CentralTicketRemoveBonification_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                    ticket.ticketWsRetrieve();
                    return false;
                });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne zrusenie bonifikacie
            main.createLog(2, "CentralTicketRemoveBonification_Failed", "# ERROR");
            ticket.ticketWsRetrieve();
            return false;
        }
    },

    // Kontrola buttonov bonifikacie voci balance
    checkBonificationButtons: function() {
        try {
            if (profile.Bonification) {
                var isApplicable, anyActive = false, btnColor = "a";
                $("#bonificationButtons .ui-radio").each(function (i, button) {
                    if ($(button).find("label").attr("applicability")) {
                        if (stored.Balance >= parseFloat($(button).find("label").attr("min-bet"))) {
                            if (stored.BonificationID && stored.BonificationID == $(button).find("input").attr("id")) anyActive = true;
                            isApplicable = stored.anyApplicableBon = true;
                        } else {
                            isApplicable = false;
                        }
                        $(button).find("input").attr("onclick", "ticket.ticketPromoModule.setBonification(" + $(button).find('input').attr('id') + ", " + isApplicable + ");");
                        $(button).find("label").attr("applicable", isApplicable);
                    }
                });

                // Nastavenie farby tlacidla Bonifikacia
                if (anyActive) {
                    btnColor = "e";
                } else if (stored.anyApplicableBon) {
                    btnColor = "b";
                }
                $("#footer-sidebar #bonificationAvailable a").buttonMarkup({theme: btnColor});

                // Ak mal oznacenu bonifikaciu a nie je mozna tak ju zrusi
                if (stored.BonificationID && (!anyActive || stored.OverallTotalBet > stored.Balance)) ticket.ticketPromoModule.removeBonification();

                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na parsovanie BoosterBonusHint
    parseBoosterBonus: function(hint, oddsTo) {
        try {
            if (hint) {
                if (!oddsTo) oddsTo = 1;
                hint = hint.split("x");
                if (hint[1]) hint[1] = hint[1].split("=");
                // Vrati info ak ostava dany pocet bodov do (zvysenia) bonusu
                if (hint[0] <= oddsTo) {
                    return hint;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na pridanie HTML do sablony
    ticketCompetitionLoad: function(addHtml) {
        $("#ticketCompetition #setContent").html(addHtml);
    },

    // Funkcia na nastavenie sutaze (rozsierenie HTML sablony a CSS)
    ticketCompetitionSet: function() {
        try {
            // Skontroluje ci ma objekt ticket a podobjekt TicketCompetitions
            if (stored.ticket && stored.ticket.TicketCompetitions && stored.ticket.TicketCompetitions.length) {
                // Nastavi objekt competition (momentalne sutaz prva v poradi, do ktorej dany SB spada)
                var competition = stored.ticket.TicketCompetitions[0];

                // Ak pre SB existuje akcia tak si stiahne dodatocne HTML a CSS
                if (competition.CompetitionID && competition.Tag) {

                    // Nastavenie Tag-u na stiahnutie aktulneho html+css zo staticu
                    if (stored.CompetitionTag != competition.Tag) {
                        stored.CompetitionTag = competition.Tag;
                        // Docasne skryje competition okno kvoli oneskoreniu pri prvom nacitani
                        $("#ticketCompetition").hide();
                        setTimeout(function () {
                            $("#ticketCompetition").show();
                        }, 500);
                        // Prida css a js do hlavicky
                        $("head #competitionCSS, head #competitionJS").remove();
                        $("head").append('<link id="competitionCSS" rel="stylesheet" href="'
                            + url.static + '/' + offer.platform + '/competitions/'
                            + stored.CompetitionTag + '/competition.css" />');
                        $("head").append('<script id=competitionJS" type="text/javascript" src="'
                            + url.static + '/' + offer.platform + '/competitions/'
                            + stored.CompetitionTag + '/competition_'
                            + offer.lang + '.js"></script>');
                    }

                    // Nastavenie aktualneho ID sutaze
                    if (!(stored.CompetitionID = parseInt(competition.CompetitionID))) stored.CompetitionID = null;

                    // Nastavenie aktualne textu, ktory sa vytlaci na sutazny listok
                    if (!(stored.CompetitionText = competition.TicketMessage)) stored.CompetitionText = "";

                    // Zobrazenie obrazovky na potvrdenie ucasti v sutazi
                    ticket.ticketPromoModule.ticketCompetitionShow();
                    return true;

                } else {
                    // Ak nema potrebne udaje k sutazi tak automaticky sutaz odmietne
                    ticket.ticketSuccess(false);
                    return false;
                }
            } else {
                // Ak nema objekt ticket tak prejde na ticketSuccess kde nalsedne zrusi podanie
                ticket.ticketSuccess(false);
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketPromoModule.ticketCompetitionSet() # " + e);
            return false;
        }
    },

    // Funkcia na potvrdenie ucasti v sutazi (nemoznost STORNOVANIA tiketu)
    ticketCompetitionShow: function() {
        try {

            if (stored.ticket && stored.CompetitionID) {
                // Cas na potvrdenie - 20 sekund (nesmie byt viac ako 60 sekund inak nastane DBjob)
                var competitionScreen = sets.competitionAck;
                if (competitionScreen > 50) competitionScreen = 50;
                dialog.open({
                    id: "ticketCompetition",
                    persistent: true
                });
                rfs.competition = setTimeout(function () {
                    ticket.ticketPromoModule.ticketCompetitionAck(false);
                }, (competitionScreen + 1) * 1000);
                modal.showLoading(competitionScreen);

                main.unlockApp();
                return true;

            } else {
                // Ak nema objekt ticket alebo competitionID tak prejde na ticketSuccess kde zrusi podanie alebo poda bez akcie
                ticket.ticketSuccess(false);
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketPromoModule.ticketCompetitionShow() # " + e);
            return false;
        }
    },

    // Funkcia na zistenie ci sa chce klient zapojit do sutaze
    ticketCompetitionAck: function(ack) {
        try {
            clearTimeout(rfs.competition);
            setTimeout(function () {
                ticket.ticketSuccess(ack);
            }, 0);

            main.closeDialog();
            delete rfs.competition;
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.closeDialog();
            delete rfs.competition;
            ticket.ticketFailed("TicketSubmit_Failed_Err", "ERROR in: ticket.ticketPromoModule.ticketCompetitionAck() # " + e);
            return false;
        }
    }
};
